export default __webpack_public_path__ + "static/media/bg4.73093e16.svg";